export const FooterPTBRTranslations = {
  footerSocialMedia: 'Redes Sociais',
  footerWorkWithUs: 'Trabalhe conosco',
  footerLinkedinLabel: 'Visite nosso linkedin',
  footerInstagramLabel: 'Visite nosso instagram',
  footerYoutubeLabel: 'Visite nosso youtube',
};
